import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
//import { Dialog, Question } from '@/modules/chatbot/controllers/Chat'
//import { DialogService } from '@/modules/chatbot/services/dialog.service'

@Module({ namespaced: true, name: 'profile' })
export class ProfileStore extends VuexModule {
  /*
  dialog: Dialog = null
  selectedQuestion: Question = null
  selectedQuestionIndex : number = 0

  @Mutation
  setDialog (dialog: Dialog) {
    this.dialog = dialog
    this.selectedQuestion = dialog.questions[0]
  }

  @Mutation
  setSelectedQuestion (question: Question) {
    this.selectedQuestion = question
  }

  @Mutation
  nextQuestion () {
    this.selectedQuestionIndex += 1
    this.selectedQuestion = this.dialog.questions[this.selectedQuestionIndex]
  }

  @Action
  async sendAnswers () {
    DialogService.sendAswers(this.dialog)
  }
  */
}
